<div fxLayout="column" fxFlex="grow" style="background-color: white;">

    <div fxLayout="row" fxFlex="grow" style="margin-top: -5px; padding: 0;">

        <mat-form-field appearance="standard" fxFlex="grow" style="padding-left: 10px; padding-right: 10px;">
            <input matInput [(ngModel)]="searchValue" placeholder="Αναζήτηση">
            <button mat-button matSuffix mat-icon-button aria-label="Clear" (click)="search(searchValue)">
                <mat-icon>search</mat-icon>
            </button>
        </mat-form-field>

    </div>


    <div fxLayout="row" class="mobile-row" fxFlex="grow">
        <div fxLayout="column" fxFlex="grow" fxLayoutGap="10px">
            <div fxLayout="row">
                <label class="heading-title">Σχετικές κατηγορίες αναζήτησης</label>
            </div>
            <div fxLayout="row wrap" fxFlex="grow" fxLayoutAlign="space-between start">
                <div (click)="search('consents')" fxLayout="column" fxFlex="49"
                     class="category-card mat-elevation-z1"
                     style="margin-right: 5px;">

                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" fxLayoutGap="5px">
                        <div fxLayout="row">
                            <mat-icon style="color: white;">grading</mat-icon>
                        </div>
                        <div fxLayout="row">
                            <label style="color: white;">Δηλώσεις συναίνεσεων</label>
                        </div>
                    </div>

                </div>
                <div (click)="search('affirmations')" fxLayout="column" fxFlex="49"
                     class="category-card mat-elevation-z1">
                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" fxLayoutGap="5px">
                        <div fxLayout="row">
                            <mat-icon style="color: white;">assignment</mat-icon>
                        </div>
                        <div fxLayout="row">
                            <label style="color: white;">Δηλώσεις εγγραφών</label>
                        </div>
                    </div>
                </div>
                <div (click)="search('announcements')" fxLayout="column" fxFlex="49" style="margin-right: 5px;"
                     class="category-card mat-elevation-z1">
                    <div fxLayout="column" fxFlex="grow" fxLayoutAlign="center center center" fxLayoutGap="5px">
                        <div fxLayout="row">
                            <mat-icon style="color: white;">campaign</mat-icon>
                        </div>
                        <div fxLayout="row">
                            <label style="color: white;">Ανακοινώσεις</label>
                        </div>
                    </div>
                </div>


            </div>
        </div>
    </div>

    <div *ngIf="loading" fxFlex="grow" fxLayout="row">
        <app-loading></app-loading>
    </div>

    <div id="pendingConsents">
        <div fxLayout="row" class="mobile-row">
            <div fxLayout="column" fxLayoutGap="10px" style="display: flex;">

                <div>
                    <label class="heading-title">Εκκρεμείς δηλώσεις</label>
                </div>

                <div [style.width.px]="rowWidth-5" style="overflow-x: auto; overflow-y: hidden; height: 270px;">
                    <table [style.width.px]="rowWidth-5">
                        <tr *ngIf="pendingConsents.length > 0">
                            <td *ngFor="let consent of pendingConsents">
                                <div class="consentCard3 mat-elevation-z2"
                                     style="background-color: white;  opacity: .85;   border-radius: 5px; color: var(--primary)">

                                    <div *ngIf="consent.mode === 'consent'"
                                         style="height:80px; background-color: var(--secondaryBlue);  border-radius: 5px 5px 0 0;  padding:10px;">
                                        <mat-card-title [matTooltip]="consent.formTitle"
                                                        style="font-size:16px; color: white;">{{ consent.formTitle | slice:0:60 }}{{consent.formTitle.length > 60 ? '...' : ''}}</mat-card-title>
                                        <mat-card-subtitle style="font-size:14px; color: white; margin-top: 5px;">
                                            Προθεσμία Υποβολής:
                                            &nbsp;<span
                                                style="font-size:16px; color: white; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                                        </mat-card-subtitle>
                                    </div>

                                    <div *ngIf="consent.mode === 'affirmation'"
                                         style="height:80px; background-color: var(--primary); border-radius: 5px 5px 0 0; padding:10px;">
                                        <mat-card-title [matTooltip]="consent.formTitle"
                                                        style="font-size:16px; color: white;">{{ consent.formTitle | slice:0:60 }}{{consent.formTitle.length > 60 ? '...' : ''}}</mat-card-title>
                                        <mat-card-subtitle style="font-size:14px; color: white; margin-top: 5px;">
                                            Προθεσμία
                                            Υποβολής: &nbsp;<span
                                                style="font-size:16px; color: white; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                                        </mat-card-subtitle>
                                    </div>

                                    <div *ngIf="consent.mode === 'customForm'"
                                         style="height:80px; background-color: var(--secondaryBlue); border-radius: 5px 5px 0 0; padding:10px;">
                                        <mat-card-title [matTooltip]="consent.formTitle"
                                                        style="font-size:16px; color: white;">{{ consent.formTitle | slice:0:60 }}{{consent.formTitle.length > 60 ? '...' : ''}}</mat-card-title>
                                        <mat-card-subtitle style="font-size:14px; color: white; margin-top: 5px;">
                                            Προθεσμία
                                            Υποβολής: &nbsp;<span
                                                style="font-size:16px; color: white; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                                        </mat-card-subtitle>
                                    </div>
                                    <mat-divider></mat-divider>

                                    <div style="margin:10px 16px 0 16px;">
                                        <div fxLayout="column" style="height:90px;">
                                            <div fxLayout="column" fxFlex="grow"
                                                 style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                                                <label style="margin-bottom: 5px; font-weight:600; color: var(--primary);">{{consent.displayName}}</label>

                                                {{consent.description}}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width:100%; height:30px;" fxLayoutAlign="center center center">
                                        <button (click)="showChildConsent(consent)" mat-flat-button
                                                style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue); border-radius: 50px;">
                                            Προβολή
                                        </button>
                                    </div>
                                </div>

                            </td>
                        </tr>
                        <tr *ngIf="pendingConsents.length === 0">
                            <th>
                                <div fxLayout="column" fxFlex="grow" style="height:250px; ">
                                    <div fxLayout="row"
                                         style="background: #ECE9E6;  /* fallback for old browsers */
background: -webkit-linear-gradient(to top, #FFFFFF, #ECE9E6);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to top, #FFFFFF, #ECE9E6); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
border: 1px solid  var(--primary);; border-radius: 5px; height:250px;"
                                         [style.width.px]="rowWidth-25" fxLayoutAlign="center center center">
                                        <div fxLayout="column" fxLayoutAlign="center center center">
<!--                                            <mat-icon style="color: green;">file_download_done</mat-icon>-->
                                            <img src="assets/images/notFound.png" style="height: 50%; width: 50%;"/>

                                            <label style="color:  var(--primary);">Δεν υπάρχουν δηλώσεις</label>
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>

    <div id="pendingAffirmations">
        <div fxLayout="row" class="mobile-row">
            <div fxLayout="column" fxLayoutGap="10px" style="display: flex;">

                <div>
                    <label class="heading-title">Διαθέσιμες δηλώσεις</label>
                </div>

                <div [style.width.px]="rowWidth-5" style="overflow-x: auto;height: 270px;">
                    <table [style.width.px]="rowWidth-5">
                        <tr *ngIf="pendingAffirmations.length > 0">
                            <td *ngFor="let consent of pendingAffirmations">
                                <div class="consentCard3 mat-elevation-z2"
                                     style="background-color: white;  opacity: .85;   border-radius: 5px; color: var(--primary)">

                                    <div *ngIf="consent.mode === 'consent'"
                                         style="height:80px; background-color: var(--secondaryBlue);  border-radius: 5px 5px 0 0;  padding:10px;">
                                        <mat-card-title [matTooltip]="consent.formTitle"
                                                        style="font-size:16px; color: white;">{{ consent.formTitle | slice:0:60 }}{{consent.formTitle.length > 60 ? '...' : ''}}</mat-card-title>
                                        <mat-card-subtitle style="font-size:14px; color: white; margin-top: 5px;">
                                            Προθεσμία Υποβολής:
                                            &nbsp;<span
                                                style="font-size:16px; color: white; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                                        </mat-card-subtitle>
                                    </div>

                                    <div *ngIf="consent.mode === 'affirmation'"
                                         style="height:80px; background-color: var(--primary); border-radius: 5px 5px 0 0; padding:10px;">
                                        <mat-card-title [matTooltip]="consent.formTitle"
                                                        style="font-size:16px; color: white;">{{ consent.formTitle | slice:0:60 }}{{consent.formTitle.length > 60 ? '...' : ''}}</mat-card-title>
                                        <mat-card-subtitle style="font-size:14px; color: white; margin-top: 5px;">
                                            Προθεσμία
                                            Υποβολής: &nbsp;<span
                                                style="font-size:16px; color: white; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                                        </mat-card-subtitle>
                                    </div>

                                    <div *ngIf="consent.mode === 'customForm'"
                                         style="height:80px; background-color: var(--secondaryBlue); border-radius: 5px 5px 0 0; padding:10px;">
                                        <mat-card-title [matTooltip]="consent.formTitle"
                                                        style="font-size:16px; color: white;">{{ consent.formTitle | slice:0:60 }}{{consent.formTitle.length > 60 ? '...' : ''}}</mat-card-title>
                                        <mat-card-subtitle style="font-size:14px; color: white; margin-top: 5px;">
                                            Προθεσμία
                                            Υποβολής: &nbsp;<span
                                                style="font-size:16px; color: white; font-weight: 900">{{consent.deadline ? consent.deadline : '-'}}</span>
                                        </mat-card-subtitle>
                                    </div>
                                    <mat-divider></mat-divider>

                                    <div style="margin:10px 16px 0 16px;">
                                        <div fxLayout="column" style="height:90px;">
                                            <div fxLayout="column" fxFlex="grow"
                                                 style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                                                <label style="margin-bottom: 5px; font-weight:600; color: var(--primary);">{{consent.displayName}}</label>

                                                {{consent.description}}
                                            </div>
                                        </div>
                                    </div>
                                    <div style="width:100%; height:30px;" fxLayoutAlign="center center center">
                                        <button (click)="showChildConsent(consent)" mat-flat-button
                                                style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue); border-radius: 50px;">
                                            Προβολή
                                        </button>
                                    </div>
                                </div>

                            </td>
                        </tr>
                        <tr *ngIf="pendingAffirmations.length === 0">
                            <th>
                                <div fxLayout="column" fxFlex="grow" style="height:250px; ">
                                    <div fxLayout="row"
                                         style="background: #ECE9E6;  /* fallback for old browsers */
background: -webkit-linear-gradient(to top, #FFFFFF, #ECE9E6);  /* Chrome 10-25, Safari 5.1-6 */
background: linear-gradient(to top, #FFFFFF, #ECE9E6); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
border: 1px solid  var(--primary);; border-radius: 5px; height:250px;"
                                         [style.width.px]="rowWidth-25" fxLayoutAlign="center center center">
                                        <div fxLayout="column" fxLayoutAlign="center center center">
<!--                                            <mat-icon style="color: green;">file_download_done</mat-icon>-->
                                            <img src="assets/images/notFound.png" style="height: 50%; width: 50%;"/>

                                            <label style="color:  var(--primary);">Δεν υπάρχουν δηλώσεις</label>
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>


    <div id="announcements">
        <div fxLayout="row" class="mobile-row">
            <div fxLayout="column" fxLayoutGap="10px" style="display: flex;">

                <div>
                    <label class="heading-title">Ανακοινώσεις</label>
                </div>

                <div [style.width.px]="rowWidth-5" style="overflow-x: auto;height: 270px;">
                    <table [style.width.px]="rowWidth-5">
                        <tr *ngIf="announcements.length > 0">
                            <td *ngFor="let consent of announcements">
                                <div class="consentCard3 mat-elevation-z2"
                                     style="background-color: white; height: 200px !important;  opacity: .85;   border-radius: 5px; color: var(--primary)">

                                    <div
                                            style="height:60px; background-color: var(--primaryOrange);  border-radius: 5px 5px 0 0;  padding:10px;">
                                        <mat-card-title [matTooltip]="consent.description"
                                                        style="font-size:16px; color: white;">{{consent.description}}</mat-card-title>
                                    </div>

                                    <mat-divider></mat-divider>
                                    <div style="margin:10px 16px 0 16px;">
                                        <div fxLayout="column" style="height:30px;">

                                            <div fxLayout="column" fxFlex="grow"
                                                 style="font-family: 'Century Gothic', sans-serif; font-size: 14px;">
                                                {{consent.child_first_name}} {{consent.child_last_name}}
                                            </div>
                                        </div>
                                    </div>

                                    <div style="width:100%; height:30px; margin-top: 20px;"
                                         fxLayoutAlign="center center center">
                                        <button disabled="true" mat-flat-button
                                                style="border:1px solid var(--secondaryBlue); color: var(--secondaryBlue); border-radius: 50px;">
                                            Προβολή
                                        </button>
                                    </div>
                                </div>

                            </td>
                        </tr>
                        <tr *ngIf="announcements.length === 0">
                            <th>
                                <div fxLayout="column" fxFlex="grow" style="height:250px;">
                                    <div fxLayout="row"
                                         style="border: 1px solid  var(--primary);; border-radius: 5px; height:250px;"
                                         [style.width.px]="rowWidth-25" fxLayoutAlign="center center center">
                                        <div fxFlex="grow" fxLayout="column" fxLayoutAlign="center center center">
                                        <img src="assets/images/notFound.png" style="height: 50%; width: 50%;"/>

                                        <label style="color:  var(--primary);">Δεν υπάρχουν ανακοινώσεις</label>
                                        </div>
                                    </div>
                                </div>
                            </th>
                        </tr>
                    </table>
                </div>
            </div>
        </div>
    </div>
<div fxLayout="row" fxFlex="grow" style="margin-bottom: 60px;"></div>
</div>
